<template>
  <router-link target="_blank" :to="linker" class="main">
    <section :class="'feed box ' + backgroundColor">
      <div class="feed-content">
        <div class="content">
          <h4 class="title is-4">
            <slot name="header">
              {{ title }}
            </slot>
          </h4>
          <div class="media">
            <p class="media-content">
              {{ desciption }}
            </p>
            <div class="cover media-right" v-if="attachment">
              <img class="image is-64x64" :src="attachment">
            </div>
          </div>
        </div>
        <div class="author">
          by&nbsp<span class="author">{{ author }}</span>
          from&nbsp<span class="board">{{ board }}</span>
        </div>
      </div>
    </section>
  </router-link>
</template>

<script>
  export default {
    name: 'feed',
    props: [
      'title',
      'desciption',
      'author',
      'board',
      'attachment',
      'linker',
      'backgroundColor'
    ]
  }
</script>

<style scoped>
.feed {
    border-radius: 0;
}
.feed-content p {
    color: #aaa;
}

.feed-content .author {
    color: #ccc;
}

.grey {
    background-color: #f2f2f5;
}

.white {
    background-color: #fff;
}
.media-content {
  overflow-wrap: break-word;
  word-wrap: break-word;

  word-break: break-word;

  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
 }
</style>





// WEBPACK FOOTER //
// Feed.vue?fc175e10